module.exports = __webpack_public_path__ + "img/element-record_selector.d22bcad.svg";